<template>
  <div class="point-details">
    <div class="table-main">
      <div class="table-header flex-wrap">
        <div class="table-header-left">
          <span>操作时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <el-button type="primary" @click="searchData">查询</el-button>
          <el-button type="success" @click="exportExcel">导出Excel表</el-button>
        </div>
        <div class="table-header-right">
          <el-pagination
            :current-page.sync="filterObj.p"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="filterObj.limit"
            layout="sizes, prev, slot, next"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            @size-change="handleSizeChange"
          >
            <div class="chax">
              {{ filterObj.p }}/{{
                itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
              }}
            </div>
          </el-pagination>
        </div>
      </div>
      <div class="table-body">
        <el-table
          :data="itemList"
          border
          stripe
          :header-cell-style="{
            background: '#4c84ff',
            color: '#fff',
            height: '60px',
            textAlign: 'center'
          }"
        >
          <el-table-column
            prop="id"
            label="积分流水编号"
            align="center"
          />
          <el-table-column prop="occur_score" label="积分变动" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.occur_score > 0
                  ? `+${scope.row.occur_score}`
                  : scope.row.occur_score
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="content"
            label="积分变动原因"
            align="center"
          />
          <el-table-column
            prop="editor_name"
            label="操作人员"
            align="center"
          />
          <el-table-column
            prop="create_time"
            label="操作时间"
            align="center"
          />
          <el-table-column prop="current_score" label="剩余积分" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.current_score - 0 + (scope.row.occur_score - 0)
              }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="filterObj.p"
          prev-text="上一页"
          next-text="下一页"
          :total="itemTotal"
          :page-size="filterObj.limit"
        >
          <div class="chax">
            {{ filterObj.p }}/{{
              itemTotal > 0 ? Math.ceil(itemTotal / filterObj.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ itemTotal }}条</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tool from '@/assets/js/tool.js'
export default {
  name: 'PointDetails',
  components: {},
  data() {
    return {
      filterObj: {
        child_id: '',
        limit: 10,
        p: 1,
        begin_time: '',
        end_time: ''
      },
      itemList: [],
      itemTotal: 0
    }
  },
  computed: {},
  watch: {
    'filterObj.p': {
      handler: function() {
        this.getInfoPoint(this.filterObj)
      }
    },
    'filterObj.limit': {
      handler: function() {
        this.getInfoPoint(this.filterObj)
      }
    }
  },
  mounted() {
    this.filterObj.child_id = this.$route.query.child_id
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
    this.getInfoPoint(this.filterObj)
  },
  methods: {
    async getInfoPoint(filterObj) {
      const ret = await this.$http.getInfoPoint(filterObj)
      if (ret.code == 200) {
        this.itemList = ret.data.list
        this.itemTotal = ret.data.count - 0
      }
    },
    handleSizeChange(val) {
      this.filterObj.limit = val
    },
    searchData() {
      this.getInfoPoint(this.filterObj)
    },
    async exportExcel() {
      const tHeader = [
        '积分流水编号',
        '积分变动',
        '积分变动原因',
        '操作人员',
        '操作时间',
        '剩余积分'
      ]
      const filterVal = [
        'id',
        'occur_score',
        'content',
        'editor_name',
        'create_time',
        'current_score'
      ]
      const ret = await this.$http.getInfoPoint({
        child_id: this.filterObj.child_id,
        limit: 9999,
        p: 1,
        begin_time: this.filterObj.begin_time,
        end_time: this.filterObj.end_time
      })
      if (ret.code == 200) {
        const list = ret.data.list
        list.forEach(e => {
          e.occur_score =
            e.occur_score > 0 ? `+${e.occur_score}` : e.occur_score
        })
        Tool.exportExcel(tHeader, filterVal, list, '积分变动详情')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.point-details {
  .table-main {
    padding-top: 30px;
    .table-header {
      flex-wrap: wrap;
      justify-content: space-between;
      .table-header-right {
        margin-bottom: 30px;
      }
      .table-header-left {
        margin-bottom: 30px;
        .el-input {
          width: 140px;
          ::v-deep .el-input__inner {
            border-color: $color_blue;
          }
        }
        span {
          color: $color_black;
          font-size: 14px;
          margin-right: 20px;
        }
        i {
          margin: 0 20px;
          font-size: 18px;
          font-style: normal;
        }
        .el-button {
          width: 90px;
          height: 40px;
          margin-left: 20px;
          &.el-button--success {
            width: 120px;
          }
        }
        .filter-notice {
          font-size: 12px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
